var render, staticRenderFns
import script from "./DragHandle.vue?vue&type=script&lang=js"
export * from "./DragHandle.vue?vue&type=script&lang=js"
import style0 from "./DragHandle.vue?vue&type=style&index=0&id=e3350498&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3350498",
  null
  
)

export default component.exports